export enum InvoiceDocumentType {
    INVOICE = 'INVOICE',
    CREDIT_NOTE = 'CREDIT_NOTE',
}
